import { render, staticRenderFns } from "./Infographic.vue?vue&type=template&id=517faacb&scoped=true&lang=pug"
import script from "./Infographic.vue?vue&type=script&lang=ts"
export * from "./Infographic.vue?vue&type=script&lang=ts"
import style0 from "./Infographic.vue?vue&type=style&index=0&id=517faacb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517faacb",
  null
  
)

export default component.exports